'use client';

// Initialise i18next côté client et fournit le contexte react-i18next.
// La détection de locale se fait au montage (navigateur) pour éviter un
// mismatch d'hydratation (le serveur rend en anglais par défaut).

import { useEffect, useState, type ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import i18n, { DEFAULT_LOCALE, detectLocale, initI18n } from './config';

export function I18nProvider({ children }: { children: ReactNode }) {
  // Init synchrone en anglais (SSR + 1er paint) → aligné avec le rendu serveur.
  const [instance] = useState(() => initI18n(DEFAULT_LOCALE));

  useEffect(() => {
    const detected = detectLocale();
    if (detected !== i18n.language) {
      void i18n.changeLanguage(detected);
    }
  }, []);

  return <I18nextProvider i18n={instance}>{children}</I18nextProvider>;
}
